import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Gauge, ShieldCheck, Clock, Award, ArrowRight } from "lucide-react";
import { BRAND } from "../lib/brand";

const STATS = [
  { num: "24/7", label: "K dispozici nonstop" },
  { num: "100%", label: "Pojištěná vozidla" },
  { num: "5+", label: "Kategorií vozidel" },
  { num: "0 Kč", label: "Skryté poplatky" },
];

const VALUES = [
  { icon: Gauge, title: "Rychle", text: "Vyřízení rezervace i předání vozu bez zbytečného čekání." },
  { icon: ShieldCheck, title: "Bezpečně", text: "Pravidelně servisovaná a pojištěná vozidla pro váš klid." },
  { icon: Clock, title: "Nonstop", text: "Jsme tu pro vás 24 hodin denně, 7 dní v týdnu." },
  { icon: Award, title: "Flexibilita", text: "Individuální přístup a řešení na míru vašim potřebám." },
];

export default function ONas() {
  return (
    <div className="bg-black" data-testid="onas-page">
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img src="/images/hero-car.jpg" alt="" className="w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-r from-black via-black/85 to-black/40" />
        </div>
        <div className="container-kame relative z-10 py-20">
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
            <p className="eyebrow">Kdo jsme</p>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white uppercase mt-2 max-w-2xl leading-[0.95]">
              KAME <span className="gold">Autopůjčovna</span>
            </h1>
            <p className="text-white/75 mt-6 max-w-xl">
              Jsme rodinná autopůjčovna z Brna, která staví na kvalitě, spolehlivosti a férovém přístupu.
              Naším cílem je, aby si u nás každý zákazník půjčil svobodu — kamkoli a kdykoli.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="container-kame py-14 grid grid-cols-2 lg:grid-cols-4 gap-6">
        {STATS.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1 }}
            className="card-kame p-6 text-center"
          >
            <p className="font-display text-4xl text-[#B58A50]">{s.num}</p>
            <p className="text-white/60 text-sm mt-2">{s.label}</p>
          </motion.div>
        ))}
      </section>

      <section className="bg-[#0a0a0a] border-y border-[#1a1a1a] py-16">
        <div className="container-kame">
          <h2 className="font-display text-3xl text-white uppercase text-center mb-12">Naše hodnoty</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {VALUES.map((v) => (
              <div key={v.title} className="card-kame p-6 hover:border-[#B58A50] transition-colors duration-200">
                <span className="w-12 h-12 rounded-sm bg-[#B58A50]/15 flex items-center justify-center text-[#B58A50] mb-4">
                  <v.icon size={24} />
                </span>
                <h3 className="font-display text-xl text-white uppercase">{v.title}</h3>
                <p className="text-white/55 text-sm mt-2">{v.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="container-kame py-16 grid md:grid-cols-2 gap-10 items-center">
        <img src="/images/hero-car.jpg" alt="KAME vůz" className="w-full rounded-sm border border-[#1a1a1a]" />
        <div>
          <p className="eyebrow">Proč právě my</p>
          <h2 className="font-display text-3xl text-white uppercase mt-2">Vozový park, na který se spolehnete</h2>
          <p className="text-white/70 mt-4">
            Od úsporných osobních vozů, přes prostorné dodávky až po luxusní limuzíny — u nás najdete vůz pro každou
            příležitost. Všechna vozidla jsou pravidelně servisovaná, čistá a připravená na cestu.
          </p>
          <p className="text-white/70 mt-3">
            Sídlíme na adrese {BRAND.address.street}, {BRAND.address.city}. Vůz vám po dohodě rádi přistavíme.
          </p>
          <Link to="/vozovy-park" className="btn-gold mt-7 inline-flex" data-testid="onas-fleet-btn">
            Prohlédnout vozy <ArrowRight size={18} />
          </Link>
        </div>
      </section>
    </div>
  );
}
